// extracted by mini-css-extract-plugin
export default {"wrapper":"lclNYAxFw5gbmH_5Xg_C","message":"vSB8qa171aL5mH7Elkps","green":"JITPMpP1o5bvayZOc_OJ"};